import { getThemesComponent } from '@namespace/themes';
import { Close as DefaultClose } from './Close';

export const Close = getThemesComponent(DefaultClose, 'Close');
